import { render, staticRenderFns } from "./InfolgtAltEditor.vue?vue&type=template&id=765cd046"
import script from "./InfolgtAltEditor.vue?vue&type=script&lang=js"
export * from "./InfolgtAltEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports